/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdMembersTitles200Ok
 */
export interface GetCorporationsCorporationIdMembersTitles200Ok {
    /**
     * character_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdMembersTitles200Ok
     */
    characterId: number;
    /**
     * A list of title_id
     * @type {Array<number>}
     * @memberof GetCorporationsCorporationIdMembersTitles200Ok
     */
    titles: Array<number>;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdMembersTitles200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdMembersTitles200Ok(value: object): value is GetCorporationsCorporationIdMembersTitles200Ok {
    if (!('characterId' in value) || value['characterId'] === undefined) return false;
    if (!('titles' in value) || value['titles'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdMembersTitles200OkFromJSON(json: any): GetCorporationsCorporationIdMembersTitles200Ok {
    return GetCorporationsCorporationIdMembersTitles200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdMembersTitles200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdMembersTitles200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'characterId': json['character_id'],
        'titles': json['titles'],
    };
}

export function GetCorporationsCorporationIdMembersTitles200OkToJSON(json: any): GetCorporationsCorporationIdMembersTitles200Ok {
    return GetCorporationsCorporationIdMembersTitles200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdMembersTitles200OkToJSONTyped(value?: GetCorporationsCorporationIdMembersTitles200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'character_id': value['characterId'],
        'titles': value['titles'],
    };
}

